import { useEffect, useState } from "react";
import "../styles/AboutTransition.css";

export default function AboutTransition() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const start = 10;
  const end = 520;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const easeInOut = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  const rawProgress = clamp((scrollY - start) / (end - start), 0, 1);

  const fadeOut = clamp((scrollY - 260) / 180, 0, 1);
  const easedFadeOut = easeInOut(fadeOut);

  const overlayOpacity = Math.min(rawProgress * 3, 1) * (1 - easedFadeOut);

  const textProgress = clamp((scrollY - 70) / (end - 70), 0, 1);
  const easedTextProgress = easeInOut(textProgress);

  const textOpacity =
    Math.min(easedTextProgress * 2.8, 1) * (1 - easedFadeOut);

  const scale = 0.12 + easedTextProgress * 4.4;
  const yMove = 20 - easedTextProgress * 220;

  return (
    <div
      className="about-transition-overlay"
      style={{
        opacity: overlayOpacity,
        visibility: overlayOpacity > 0.01 ? "visible" : "hidden",
      }}
    >
      <h1
        className="about-transition-title"
        style={{
          opacity: textOpacity,
          transform: `translateY(${yMove}px) scale(${scale})`,
        }}
      >
        <span>ABOUT</span>
        <span>US</span>
      </h1>
    </div>
  );
}